const dev = false;

//const prod_path     = 'https://teoflybackend.brooklynwebsite.com/api';
const prod_path     = 'https://360.teofly.com/api';
// const prod_path     = 'http://360.teofly.local:8080/api';

//const shared_url    = 'https://teofly.brooklynwebsite.com/';
const shared_url    = 'https://360.teofly.com/';
// const shared_url    = 'http://360.teofly.local:8080/';
const token         = 'pk.eyJ1IjoibWdyYiIsImEiOiJja2NnaW9oOWgwZTR4MnFwYWs4YWRqajJrIn0.di_m-Mt1-eQdtPhFT6ktdQ';

export const url_path = {
    //auth
    url_users_get_current_user: prod_path + '/get_current_user',
    url_users_login:            prod_path + '/login',
    url_users_logout:           prod_path + '/logout',
    url_refresh_token:          prod_path + '/refreshtoken',

    //projects
    url_projects_list:          prod_path + '/projects/list',
    url_projects_view:          prod_path + '/projects/view/',
    url_projects_add:           prod_path + '/projects/add',
    url_projects_edit:          prod_path + '/projects/edit/',
    url_projects_delete:        prod_path + '/projects/delete/',
    url_projects_delete_perm:   prod_path + '/projects/delete/',
    url_projects_restore:       prod_path + '/projects/delete/',

    //share endpoints
    url_share_layers_list:      prod_path + '/share/projects_layers/list/',
    url_share_layers_view:      prod_path + '/share/projects_layers/view/',

    //layers
    url_layers_list:            prod_path + '/projects_layers/list/',
    url_layers_view:            prod_path + '/projects_layers/view/',
    url_layers_add:             prod_path + '/projects_layers/add',
    url_layers_edit:            prod_path + '/projects_layers/edit/',
    url_layers_delete:          prod_path + '/projects_layers/delete/',

    //documents
    url_documents_add:          prod_path + '/projects/upload',
    url_documents_edit:         prod_path + '/projects_documents/edit/',
    url_documents_delete:       prod_path + '/projects_documents/delete/',
    url_documents_finish:       prod_path + '/projects_documents/upload_finished',

    //other
    response_status_ok:         'ok',
    dev_server:                 dev,
    shared_url:                 shared_url,
    leaflet_token:              token
}
